<template>
    <p class="control">
      <multiselect @input="emitProject()"
        v-model="standardProject" 
        :options="projectInput"
        group-values="task"
        group-label="no"
        :placeholder="$t('input.chooseProject')"
        track-by="task_no"
        label="description"
        :select-label="$t('input.choose')"
        :deselect-label="$t('input.remove')">
        <span slot="noResult">{{$t("input.noProjectFound")}}</span>
      </multiselect>
    </p>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ProjectSelect',
  components: {
      Multiselect
    },
  props: {
    useCustomProjects: Boolean,
    allProjectLines: Array,
    allProjectDesc: Array,
    allProjects: Array,
    projectFavorites: Array,
    customProjects: Object,
    customProjectLines: Object,
    useStandardProject: Boolean,
    standardProject: Object,
  },
  data: function() {
      return {
        navProjectLines: [],
        projects: {},
      }
  },
mounted() {
  if(this.useStandardProject) {
    try {
        this.$emit('project', this.standardProject.no);
        this.$emit('projectTask', this.standardProject.task_no);
      } catch(err) {
        console.log("Error: ", err.message);
      }
  }
},
  computed: {
    projectInput() {
        if(this.useCustomProjects) {
          return this.groupCustomProjects;
        } else {
          return this.groupProjectLines
        }
    },
    groupCustomProjects() {
      if(this.useCustomProjects) {
        const self = this;
        let groupedProjectsArray = []
        groupedProjectsArray = _.map(this.customProjects, function(project,pkey) {
          return {
            key: pkey,
            no: project.name,
            task: _.without(_.map(self.customProjectLines, function(line, plkey) {
              if(pkey === line.project) {
                return {
                  no: pkey,
                  task_no: plkey,
                  description: line.name
                }
              } else {
                return null;
              }
            }), null)
          }
        })
        return groupedProjectsArray
      } else {
        return null;
      }
    },
    groupProjectLines: function() {
      // merge all project tasks with favorites if project & task is fav
      function mergeByJob(objValue, srcValue, key, object, source, stack){
        if (object.Job_No == source.Job_No && object.Job_Task_No == source.Job_Task_No) {
          // console.log("key: ", key)
          // console.log("object: ", object.Job_No)
          _.merge(objValue, {favorite: true});
        }
      }
      _.mergeWith(this.allProjectLines, this.projectFavorites, mergeByJob);
      // set variable for description search
      var desc = this.allProjectDesc;
      // set variable for project description substitution
      var projects = this.allProjects;
      var result = _.chain(this.allProjectLines).groupBy("no").map(function(v, i) {
        return {
          // find project description
          no: _.get(_.find(projects, {'no': i}), 'description') + ' (' + i + ')', //i,
          task:
            _.chain(v).groupBy("task_no").map(function(v2, i2) {
              // if favorite add star to description
              var fav = '';
              if (_.get(_.find(v2, 'favorite'), 'favorite') == true) {
                fav = '★ '
              }
              return {
                no: i,
                task_no: i2,
                description: fav + _.get(_.find(desc, {'no': i, 'task_no': i2}), 'description') + ' (' + i2 + ')',
              }
          }).value()
        }
      }).value();
      // TODO: reverse in order to get favorites first TODO fix sort order
      return result;
    }
  },
  methods: {
    emitProject: function() {
      try {
        this.$emit('project', this.standardProject.no);
        this.$emit('projectTask', this.standardProject.task_no);
      } catch(err) {
        console.log("Error: ", err.message);
      }
    }
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
